import { BaseWorkflowRuleCollection } from '@/modules/workflow/models/BaseWorkflowRuleCollection';
import { WorkflowPaymentStatusRule } from '/@/modules/workflow/models/WorkflowPaymentStatusRule';
import Lang from '@/modules/core/app/services/Lang';
import { WorkflowRuleType } from '/@/modules/workflow/enums/WorkflowRuleType';
import { EstatePaymentStatus } from '@/modules/estate/constants/EstatePaymentStatus';

export class WorkflowPaymentStatusRuleCollection extends BaseWorkflowRuleCollection<WorkflowPaymentStatusRule> {
  constructor(
    items: WorkflowPaymentStatusRule[] | WorkflowPaymentStatusRuleCollection | undefined
  ) {
    super(items, WorkflowPaymentStatusRule);
  }

  static mapModel(
    items: WorkflowPaymentStatusRule[] | WorkflowPaymentStatusRuleCollection | undefined
  ): WorkflowPaymentStatusRuleCollection {
    return new this(items);
  }

  get paymentStatuses(): EstatePaymentStatus[] {
    return (
      this.items?.map(
        (estateRule: WorkflowPaymentStatusRule): EstatePaymentStatus =>
          EstatePaymentStatus.getByKey(estateRule.paymentStatus) as EstatePaymentStatus
      ) ?? []
    );
  }

  sync(paymentStatusSelection: EstatePaymentStatus[]): void {
    super.syncRules(
      paymentStatusSelection.map(
        (paymentStatus: EstatePaymentStatus): WorkflowPaymentStatusRule =>
          WorkflowPaymentStatusRule.mapModel({
            paymentStatus: paymentStatus.key
          })
      )
    );
  }

  get ruleText(): string {
    return this.count > 1
      ? Lang.t('workflow.payment-status-in')
      : Lang.t('workflow.payment-status-is');
  }

  get ruleType(): string {
    return WorkflowRuleType.PAYMENT_STATUS.key;
  }

  get ruleSelection(): EstatePaymentStatus[] {
    return this.paymentStatuses;
  }
}
